import { Text } from '@react-three/drei';
import { useGame } from '../board/score-context';

export function GameOverText() {
  const { balls, score } = useGame();

  if (balls > 0) return null;

  return (
    <group>
      {/* Dark overlay */}
      <mesh position={[0, 0, 2]} renderOrder={-1}>
        <planeGeometry args={[100, 100]} />
        <meshBasicMaterial color="#000000" transparent opacity={0.5} />
      </mesh>

      {/* Game Over text */}
      <Text position={[0, 0, 3]} fontSize={2} color="#ffffff" anchorX="center" anchorY="middle">
        Good job!
      </Text>

      <Text position={[0, -2.5, 2]} fontSize={1} color="#ffffff" anchorX="center" anchorY="middle">
        You scored {score} points
      </Text>

      <Text position={[0, -4, 2]} fontSize={1} color="#ffffff" anchorX="center" anchorY="middle">
        Refresh to play again
      </Text>
    </group>
  );
}
